import React, { useContext } from 'react'
import { ProgressBar, Button, makeStyles } from '@fluentui/react-components'
import { t } from '../../i18n/i18n'
import { getDefaultValues } from '../../helpers/demandAssessmentHelper'
import { ModalActions } from '../common/modal/Modal'
import { Text } from '../common/text/Text'
import { UseFormReturn } from 'react-hook-form'
import { DataContext } from '../../context/DataContext'
import { IComplianceState } from '../../interfaces/IComplianceState'
import { useNavigate } from 'react-router-dom'
import { NavigationLink } from '../../interfaces/INavigationLink'
import { DraggableModal } from '../common/modal/DraggableModal'
import { DemandAssessmentFormValues } from './DemandAssessmentForm'
const useStyles = makeStyles({
   btnRight: { justifyContent: 'end' },
})
type ModalLoadingDemandAssessmentProps = {
   demandAssessmentForm: UseFormReturn<DemandAssessmentFormValues>
   setComplianceState: React.Dispatch<React.SetStateAction<IComplianceState>>
   complianceState: IComplianceState
   error: string
   isNetworkError?: boolean
}
export const ModalLoadingDemandAssessment = ({ demandAssessmentForm, setComplianceState, complianceState, error, isNetworkError }: ModalLoadingDemandAssessmentProps) => {
   const dataContext = useContext(DataContext)
   const {
      reset,
      getValues,
      formState: { isSubmitting, isSubmitSuccessful, isValid },
   } = demandAssessmentForm
   const classes = useStyles()
   const navigate = useNavigate()
   const openDemandAssessment = () => {
      setComplianceState((prev) => ({ ...prev, demandAnalyses: [...prev.allDemandAssessments, getValues()] }))
      navigate(NavigationLink.ComplianceOfDemands + '/' + getValues().id)
      reset(getDefaultValues(dataContext, complianceState))
   }

   return (
      <DraggableModal
         title={isSubmitting ? t('CreatingDemandAssessment') : error ? (isNetworkError ? t('SomethingWentWrong') : t('CouldNotCreateItem', { Item: t('DemandAssessment') })) : t('DemandAssessmentCreated')}
         open={isValid && (isSubmitting || isSubmitSuccessful)}
         noCloseButton
         noDivider
      >
         {isSubmitting ? (
            <>
               <ProgressBar />
               <Text>{t('ThisCanTakeAMoment')}</Text>
            </>
         ) : error ? (
            <Text>
               {t('ErrorMessage')}: {error}
            </Text>
         ) : (
            <Text>{t('ClickContinueToGoToAssessment')}</Text>
         )}
         <ModalActions className={classes.btnRight}>
            {error ? (
               <Button onClick={() => reset(getDefaultValues(dataContext, complianceState))}>{t('Close')}</Button>
            ) : isSubmitSuccessful ? (
               <Button appearance="primary" onClick={openDemandAssessment}>
                  {t('Continue')}
               </Button>
            ) : null}
         </ModalActions>
      </DraggableModal>
   )
}
